import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';
import Person from "../Person";
import CashDesk from "../CashDesk";
import BankAccount from "../BankAccount";
import WorkFlowStepLogging from "../BPMS/WorkFlowStepLogging";

export default class Receipt extends Base {
	constructor(props) {
		super(props);
		this.state = {
			enableDatePicker: false,
			caller: props.Caller,
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			type: this.isNull(props.Type) ? 0 : props.Type,
			factorId: this.isNull(props.FactorId) ? this.defaultGuid() : props.FactorId,
			installmentScheduleId: this.isNull(props.InstallmentScheduleId) ? this.defaultGuid() : props.InstallmentScheduleId,
			//billExpenseId: this.isNull(props.BillExpenseId) ? this.defaultGuid() : props.BillExpenseId,
			buildingId: this.isNull(props.BuildingId) ? this.defaultGuid() : props.BuildingId,
			unitId: null,
			source: this.isNull(props.Source) ? 1 : props.Source,
			refreshAfterSave: this.isNull(props.RefreshAfterSave) ? true : props.RefreshAfterSave,
			data: null,
			loading: true,
			version: this.uuidv4(),
			version2: this.uuidv4()
		};
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();
		this.httpPost("api/v1/receipt/get", {
			id: this.state.id,
			type: this.state.type,
			source: this.state.source,
			factorId: this.state.factorId,
			installmentScheduleId: this.state.installmentScheduleId,
			//billExpenseUnitId: this.state.billExpenseUnitId
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.setState({
						data: data,
						loading: false
					});
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	save() {
		var receiptItems = [];

		this.state.data.receiptItems.forEach(i => {
			var clone = Object.assign({}, i);
			if (!this.isBlank(clone.chequeDate)) clone.chequeDate = this.convertMomentToDb(clone.chequeDate);
			receiptItems.push(clone);
		});

		this.httpPost("api/v1/receipt/save", {
			id: this.state.data.record.id,
			organizationId: this.state.data.global.company.id,
			description: this.state.data.record.description,
			note: this.state.data.record.note,
			type: this.state.data.record.type,
			date: (this.state.enableDatePicker === true ? this.convertMomentToDb(this.state.data.record.date) : this.state.data.record.dateString),
			toDate: (this.state.enableDatePicker === true ? this.convertMomentToDb(this.state.data.record.toDate) : this.state.data.record.toDateString),
			moeinAccountId: this.state.data.record.moeinAccountId,
			tafsilAccountId: this.state.data.record.tafsilAccountId,
			objectType: this.state.data.record.objectType,
			personId: this.state.data.record.personId,
			factorId: this.state.data.record.factorId,
			installmentScheduleId: this.state.data.record.installmentScheduleId,
			billExpenseUnitId: this.state.data.record.billExpenseUnitId,
			source: this.state.data.record.source,
			receiptItems,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("رسید با موفقیت ذخیره شد");
					if (this.state.refreshAfterSave) this.state.caller.refreshData();
					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	getBlankRow(objectType, chequeDate = null) {
		return {
			id: this.uuidv4(),
			objectType: objectType,
			stuffId: this.defaultGuid(),
			price: 0,
			price2: 0,
			currencyRate: 0,//this.state.data.global.company.currencyRate,
			currencyId: null,
			description: '',
			fishNumber: '',
			chequeId: this.defaultGuid(),
			chequeInfoId: this.defaultGuid(),
			cashDeskId: null,
			bankAccountId: this.defaultGuid(),
			chequeNumber: 0,
			guarantee: false,
			sayyadi: '',
			chequeDate: chequeDate,
			bankName: '',
			bankId: this.getDefaultGuid(),
			branch: '',
			personId: null,
			attachment: '',
			fromAccountId: null,
			toAccountId: null,
			fromAccountName: '',
			toAccountName: '',
			wage: 0,
			priceTo: 0,
			currencyRateTo: 0,
			priceTo2: 0,
			currencyToId: null,
		};
	}
	addNewRow() {
		var v = this.getBlankRow(0);
		this.state.data.receiptItems.push(v);
		this.setState({ data: this.state.data });
	}
	addNewNagdRow() {
		var v = this.getBlankRow(1);
		v.cashDeskId = this.defaultGuid();
		this.state.data.receiptItems.push(v);
		this.setState({ data: this.state.data });
	}
	addNewChequeRow() {
		var v = this.getBlankRow(3, this.state.data.record.date);
		this.state.data.receiptItems.push(v);
		this.setState({ data: this.state.data });
	}
	addNewSafteRow() {
		var v = this.getBlankRow(6, this.state.data.record.date);
		this.state.data.receiptItems.push(v);
		this.setState({ data: this.state.data });
	}    
	addNewFishRow() {
		var v = this.getBlankRow(2);
		this.state.data.receiptItems.push(v);
		this.setState({ data: this.state.data });
	}
	removeRow(id) {
		var t = [];
		this.state.data.receiptItems.forEach(i => {
			if (i.id != id) {
				t.push(i);
			}
		});
		this.state.data.receiptItems = t;
		this.updateFormula();
	}
	setItemValue(f, e, id) {
		this.state.data.receiptItems.forEach(i => {
			if (i.id === id) {
				if (f === 'bankId' || f === 'fromAccountId' || f === 'toAccountId') {
					i[f] = e.value;
					if (f === 'bankId')
						i['bankName'] = e.label;
					if (f === 'fromAccountId')
						i['fromAccountName'] = e.label;
					if (f === 'toAccountId')
						i['toAccountName'] = e.label;
				}
				else {
					i[f] = e;

					if (f == "price") {
						if (i.currencyRate == 0) i.price2 = 0;
						else i.price2 = this.FixedPointNumber(parseInt(i.price) / i.currencyRate, 2);
						this.state.version2 = this.uuidv4();
					}
					if (f == "priceTo") {
						if (i.currencyRateTo == 0) i.priceTo2 = 0;
						else i.priceTo2 = this.FixedPointNumber(parseInt(i.priceTo) / i.currencyRateTo, 2);
						this.state.version2 = this.uuidv4();
					}

					if (f == "price2") {
						if (i.currencyRate == 0) i.price = 0;
						else i.price = this.FixedPointNumber(parseInt(i.price2) * i.currencyRate, 0);
						this.state.version = this.uuidv4();
					}
					if (f == "priceTo2") {
						if (i.currencyRateTo == 0) i.priceTo = 0;
						else i.priceTo = this.FixedPointNumber(parseInt(i.priceTo2) * i.currencyRateTo, 0);
						this.state.version = this.uuidv4();
					}

					if (f == "currencyRate") {
						if (i.currencyRate == 0) {
							i.price = 0;
							i.price2 = 0;
						}
						else {
							i.price2 = this.FixedPointNumber(parseInt(i.price) / i.currencyRate, 2);
						}
						this.state.version2 = this.uuidv4();
					}
					if (f == "currencyRateTo") {
						if (i.currencyRateTo == 0) {
							i.priceTo = 0;
							i.priceTo2 = 0;
						}
						else {
							i.priceTo2 = this.FixedPointNumber(parseInt(i.priceTo) / i.currencyRateTo, 2);
						}
						this.state.version2 = this.uuidv4();
					}
				}
			}
		});
		this.updateFormula();
	}
	updateFormula() {
		var t = 0;
		this.state.data.receiptItems.forEach(i => {
			if (!this.isBlank(i.price)) t += i.price;
		});
		this.state.data.record.total = t;
		this.setState({ data: this.state.data });
	}
	renderNagdBox(item) {
		return <div className="row mr-10 acc-pay-get-box" style={{ "background-color": "#337AB7", "border": "1px solid #337AB7", "position": "relative" }} >
			<div className="col-sm-1 text-center" style={{ "min-height": "58px", "display": "table" }} >
				<div style={{ "display": "table-cell", "vertical-align": "middle", "color": "white" }} >وجه نقد</div>
			</div>
			<div className="col-sm-11 pd-10" style={{ "background-color": "white", "color": "rgb(34, 34, 34)" }} >
				<div className="row p-1" style={{ "margin-left": "5px" }}>
					<div className="col-sm-3" key={this.state.version + item.id + "_price"}>
						مبلغ ({this.state.data.global.company.currencyUnit})<span className="red">*</span>:
						<input defaultValue={item.price} onChange={e => this.setItemValue('price', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>
					{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-sm-3">ارز<span className="red">*</span>:
						<select defaultValue={item.currencyId} onChange={e => this.setItemValue('currencyId', e.target.value, item.id)} className='form-control text-center ltr'>
							<option value="">انتخاب</option>
							{this.state.data.global.currencies.map(cur => <option value={cur.value}>{cur.label}</option>)}
						</select>
					</div>}
					{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-sm-3">نرخ ارز<span className="red">*</span>:
						<input value={item.currencyRate} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>}
					{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-sm-3" key={this.state.version2 + item.id + "_price2"}>مبلغ ارزی<span className="red">*</span>:
						<input defaultValue={item.price2} onChange={e => this.setItemValue('price2', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>}

					<div className="col-sm-2">
						صندوق<span className="red">*</span>:
						<SelectAsync
							defaultValue={item.cashDeskId != this.defaultGuid() ? [{ value: item.cashDeskId, label: item.cashDeskName }] : null}
							isMulti={false}
							placeholder="انتخاب صندوق"
							defaultOptions
							loadOptions={(inputValue, callback) => this.loadCashdesksOptions(inputValue, callback, 1)}
							onChange={e => this.setCashdesk(e, item.id)}
						/>
					</div>
					<div className="col-sm-7">
						شرح:
						<input defaultValue={item.description} onChange={e => this.setItemValue('description', e.target.value, item.id)} autocomplete="off" type="text" className="description col-sm-11 form-control input-sm" />
					</div>
					<div className="col-lg-3">
						<div className="form-group">
							<label className="form-label">آپلود پیوست:</label>
							<div className="form-control-wrap">
								<input type="file" accept="image/*" onChange={(e) => this.handleAttachmentChange(e, item.id)} />
								{item.progress > 0 && (
									<div style={{ width: '100%', backgroundColor: '#eee', marginTop: '5px' }}>
										<div style={{ width: `${item.progress}%`, backgroundColor: 'green', color: 'white', padding: '0', textAlign: 'center', }} >
											{item.progress}%
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
					{!this.isBlank(item.attachmentUrl) && <div className="col-lg-3">
						<div className="form-group">
							<a href={item.attachmentUrl} target="_blank">مشاهده پیوست</a>}
						</div>
					</div>}
					<div className="col-lg-3">
						<div className="form-group">
							<label className="form-label">آپلود پیوست:</label>
							<div className="form-control-wrap">
								<input type="file" accept="image/*" onChange={(e) => this.handleAttachmentChange(e, item.id)} />
								{item.progress > 0 && (
									<div style={{ width: '100%', backgroundColor: '#eee', marginTop: '5px' }}>
										<div style={{ width: `${item.progress}%`, backgroundColor: 'green', color: 'white', padding: '0', textAlign: 'center', }} >
											{item.progress}%
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
					{!this.isBlank(item.attachmentUrl) && <div className="col-lg-3">
						<div className="form-group">
							<a href={item.attachmentUrl} target="_blank">مشاهده پیوست</a>}
						</div>
					</div>}
					<div className="col-lg-3">
						<div className="form-group">
							<label className="form-label">آپلود پیوست:</label>
							<div className="form-control-wrap">
								<input type="file" accept="image/*" onChange={(e) => this.handleAttachmentChange(e, item.id)} />
								{item.progress > 0 && (
									<div style={{ width: '100%', backgroundColor: '#eee', marginTop: '5px' }}>
										<div style={{ width: `${item.progress}%`, backgroundColor: 'green', color: 'white', padding: '0', textAlign: 'center', }} >
											{item.progress}%
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
					{!this.isBlank(item.attachmentUrl) && <div className="col-lg-3">
						<div className="form-group">
							<a href={item.attachmentUrl} target="_blank">مشاهده پیوست</a>
						</div>
					</div>}
				</div>
			</div>
			<a onClick={e => this.removeRow(item.id)} className="hand" style={{ "width": "10px", "height": "20px", "position": "absolute", "color": "#3379b6", "left": "0", "cursor": "pointer", "top": "0" }}>x</a>
		</div>
	}
	renderFishBox(item) {
		return <div className="row mr-10 acc-pay-get-box" style={{ "background-color": "#9e32bd", "border": "1px solid #9e32bd", "position": "relative" }}>
			<div className="col-sm-1 text-center" style={{ "min-height": "58px", "display": "table" }}>
				<div style={{ "display": "table-cell", "vertical-align": "middle", "color": "white" }}>فیش بانکی</div>    </div>
			<div className="col-sm-11 pd-10" style={{ "background-color": "white", "color": "rgb(34, 34, 34)" }}>
				<div className="row p-1" style={{ "margin-left": "5px" }}>
					<div className="col-sm-3" key={this.state.version + item.id + "_price"}>مبلغ ({this.state.data.global.company.currencyUnit})<span className="red">*</span>:
						<input defaultValue={item.price} onChange={e => this.setItemValue('price', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>

					{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-sm-3">ارز<span className="red">*</span>:
						<select defaultValue={item.currencyId} onChange={e => this.setItemValue('currencyId', e.target.value, item.id)} className='form-control text-center ltr'>
							<option value="">انتخاب</option>
							{this.state.data.global.currencies.map(cur => <option value={cur.value}>{cur.label}</option>)}
						</select>
					</div>}
					{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-sm-3">نرخ ارز<span className="red">*</span>:
						<input value={item.currencyRate} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>}
					{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-sm-3" key={this.state.version2 + item.id + "_price2"}>مبلغ ارزی<span className="red">*</span>:
						<input defaultValue={item.price2} onChange={e => this.setItemValue('price2', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>}

					<div className="col-sm-2">
						شماره فیش/ارجاع:
						<input defaultValue={item.fishNumber} onChange={e => this.setItemValue('fishNumber', e.target.value, item.id)} autocomplete="off" type="text" className="fish_number col-sm-2 form-control input-sm" /></div>
					<div className="col-sm-2">
						بانک<span className="red">*</span>:
						<SelectAsync
							defaultValue={item.bankAccountId != this.defaultGuid() ? [{ value: item.bankAccountId, label: item.bankAccountName }] : null}
							isMulti={false}
							placeholder="انتخاب بانک"
							defaultOptions
							loadOptions={(inputValue, callback) => this.loadBankAccountsOptions(inputValue, callback, 1)}
							onChange={e => this.setBankAccount(e, item.id)}
						/>
					</div>
					<div className="col-sm-5">
						شرح:
						<input defaultValue={item.description} onChange={e => this.setItemValue('description', e.target.value, item.id)} autocomplete="off" type="text" className="description col-sm-11 form-control input-sm" />
					</div>
					<div className="col-lg-3">
						<div className="form-group">
							<label className="form-label">آپلود پیوست:</label>
							<div className="form-control-wrap">
								<input type="file" accept="image/*" onChange={(e) => this.handleAttachmentChange(e, item.id)} />
								{item.progress > 0 && (
									<div style={{ width: '100%', backgroundColor: '#eee', marginTop: '5px' }}>
										<div style={{ width: `${item.progress}%`, backgroundColor: 'green', color: 'white', padding: '0', textAlign: 'center', }} >
											{item.progress}%
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
					{!this.isBlank(item.attachmentUrl) && <div className="col-lg-3">
						<div className="form-group">
							<a href={item.attachmentUrl} target="_blank">مشاهده پیوست</a>
						</div>
					</div>}
				</div>
			</div>
			<a onClick={e => this.removeRow(item.id)} className="hand" style={{ "width": "10px", "height": "20px", "position": "absolute", "color": "#9e32bd", "left": "0", "cursor": "pointer", "top": "0" }}>x</a>
		</div>
	}
	renderOnlinePay(item) {
		return <div className="row mr-10 acc-pay-get-box" style={{ "background-color": "#9e32bd", "border": "1px solid #9e32bd", "position": "relative" }}>
			<div className="col-sm-1 text-center" style={{ "min-height": "58px", "display": "table" }}>
				<div style={{ "display": "table-cell", "vertical-align": "middle", "color": "white" }}>پرداخت آنلاین</div>
			</div>
			<div className="col-sm-11 pd-10" style={{ "background-color": "white", "color": "rgb(34, 34, 34)" }}>
				<div className="row p-1" style={{ "margin-left": "5px" }}>
					<div className="col-sm-3" key={this.state.version + item.id + "_price"}>مبلغ ({this.state.data.global.company.currencyUnit})<span className="red">*</span>:
						<input defaultValue={item.price} onChange={e => this.setItemValue('price', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>

					{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-sm-3">ارز<span className="red">*</span>:
						<select defaultValue={item.currencyId} onChange={e => this.setItemValue('currencyId', e.target.value, item.id)} className='form-control text-center ltr'>
							<option value="">انتخاب</option>
							{this.state.data.global.currencies.map(cur => <option value={cur.value}>{cur.label}</option>)}
						</select>
					</div>}
					{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-sm-3">نرخ ارز<span className="red">*</span>:
						<input value={item.currencyRate} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>}
					{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-sm-3" key={this.state.version2 + item.id + "_price2"}>مبلغ ارزی<span className="red">*</span>:
						<input defaultValue={item.price2} onChange={e => this.setItemValue('price2', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>}

					<div className="col-sm-2">
						شماره فیش/ارجاع:
						<input defaultValue={item.fishNumber} onChange={e => this.setItemValue('fishNumber', e.target.value, item.id)} autocomplete="off" type="text" className="fish_number col-sm-2 form-control input-sm" /></div>
					<div className="col-sm-5">
						شرح:
						<input defaultValue={item.description} onChange={e => this.setItemValue('description', e.target.value, item.id)} autocomplete="off" type="text" className="description col-sm-11 form-control input-sm" />
					</div>
					<div className="col-lg-3">
						<div className="form-group">
							<label className="form-label">آپلود پیوست:</label>
							<div className="form-control-wrap">
								<input type="file" accept="image/*" onChange={(e) => this.handleAttachmentChange(e, item.id)} />
								{item.progress > 0 && (
									<div style={{ width: '100%', backgroundColor: '#eee', marginTop: '5px' }}>
										<div style={{ width: `${item.progress}%`, backgroundColor: 'green', color: 'white', padding: '0', textAlign: 'center', }} >
											{item.progress}%
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
					{!this.isBlank(item.attachmentUrl) && <div className="col-lg-3">
						<div className="form-group">
							<a href={item.attachmentUrl} target="_blank">مشاهده پیوست</a>
						</div>
					</div>}
				</div>
			</div>
			<a onClick={e => this.removeRow(item.id)} className="hand" style={{ "width": "10px", "height": "20px", "position": "absolute", "color": "#9e32bd", "left": "0", "cursor": "pointer", "top": "0" }}>x</a>
		</div>
	}	
	renderChequeBox(item) {
		return <div className="row mr-10 acc-pay-get-box " style={{ "background-color": "#bd6532", "border": "1px solid #bd6532", "position": "relative" }}>
			<div className="col-sm-1 text-center" style={{ "min-height": "85px", "display": "table" }}>
				<div style={{ "display": "table-cell", "vertical-align": "middle", "color": "white" }}>چـک</div>
			</div>
			<div className="col-sm-11 pd-10" style={{ "background-color": "white", "color": "rgb(34, 34, 34)" }}>
				<div className="row p-1" style={{ "margin-left": "5px" }}>
					<div className="col-sm-3" key={this.state.version + item.id + "_price"}>
						مبلغ ({this.state.data.global.company.currencyUnit})<span className="red">*</span>:
						<input defaultValue={item.price} onChange={e => this.setItemValue('price', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>

					{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-sm-3">ارز<span className="red">*</span>:
						<select defaultValue={item.currencyId} onChange={e => this.setItemValue('currencyId', e.target.value, item.id)} className='form-control text-center ltr'>
							<option value="">انتخاب</option>
							{this.state.data.global.currencies.map(cur => <option value={cur.value}>{cur.label}</option>)}
						</select>
					</div>}
					{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-sm-3">نرخ ارز<span className="red">*</span>:
						<input value={item.currencyRate} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>}
					{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-sm-3" key={this.state.version2 + item.id + "_price2"}>مبلغ ارزی<span className="red">*</span>:
						<input defaultValue={item.price2} onChange={e => this.setItemValue('price2', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>}
					{this.state.data.record.type === 1 &&
						<div className="col-sm-2">
							شماره چک<span className="red">*</span>:
							<input defaultValue={item.chequeNumber} onChange={e => this.setItemValue('chequeNumber', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="cheque_number col-sm-2 form-control input-sm" />
						</div>
					}
					<div className="col-sm-2">
						شماره صیادی:
						<input defaultValue={item.sayyadi} onChange={e => this.setItemValue('sayyadi', e.target.value, item.id)} autocomplete="off" type="text" className="cheque_number col-sm-2 form-control input-sm" />
					</div>
					{this.state.data.record.type === 2 && item.bankAccountId != this.defaultGuid() && <div className="col-sm-2">
							شماره چک<span className="red">*</span>:
							<SelectAsync
							defaultValue={item.chequeNumber > 0 ? [{ value: item.chequeId, label: item.chequeNumber }] : null}
								isMulti={false}
								placeholder="انتخاب چک"
								defaultOptions
								loadOptions={(inputValue, callback) => this.loadChequeNumbersOptions(inputValue, callback, item.bankAccountId)}
								onChange={e => {
									this.setItemValue('chequeId', e.value, item.id);
									this.setItemValue('chequeNumber', e.number, item.id);
								}
								}
							/>
						</div>}
					<div className="col-sm-2">
						تاریخ چک<span className="red">*</span>:
						<DatePicker
							inputReadOnly={false}
							className="form-control input-sm persian-date col-sm-2"
							placeholder={"تاریخ"}
							isGregorian={false}
							showTodayButton={true}
							timePicker={false}
							onChange={(e) => { this.setItemValue('chequeDate', e, item.id) }}
							value={this.getFormatedDateForDatePicker(item.chequeDate)}
						/>
					</div>
					{this.state.data.record.type === 1 && <div className="col-sm-3">
						بانک:
						<SelectAsync
							style={{ "width": "100%" }}
							defaultValue={item.bankId !== this.getDefaultGuid() ? [{ value: item.bankId, label: item.bankName }] : null}
							isMulti={false}
							placeholder="جستجو و انتخاب بانک"
							noOptionsMessage={({ inputValue }) =>
								inputValue ? "نتیجه‌ای یافت نشد" : null
							}
							//defaultOptions={[]}
							components={{
								// DropdownIndicator: () => null,
								IndicatorSeparator: () => null,
							}}
							loadOptions={(inputValue, callback) => this.loadBanksOptions(inputValue, callback)}
							onChange={e => this.setItemValue('bankId', e, item.id)}
						/>
					</div>}
					{this.state.data.record.type === 2 && <div className="col-sm-3">
						بانک:
						<SelectAsync
							defaultValue={item.bankAccountId != this.defaultGuid() ? [{ value: item.bankAccountId, label: item.bankAccountName }] : null}
							isMulti={false}
							placeholder="انتخاب بانک"
							defaultOptions
							loadOptions={this.loadBankAccountsOptions}
							onChange={e => {
								this.setItemValue('bankAccountId', e.value, item.id);
								this.setItemValue('bankAccountName', e.label, item.id);
							}
							}
						/>
					</div>}
					{this.state.data.record.type === 1 && <div className="col-sm-2">
						شعبه:
						<input defaultValue={item.branch} onChange={e => this.setItemValue('branch', e.target.value, item.id)} autocomplete="off" maxlength="50" type="text" className="cheque_branch col-sm-2 form-control input-sm" />
					</div>}
					<div className="col-sm-1" style={{ "display": "flex", "align-items": "center", "gap": "5px" }}>
						<input defaultChecked={item.guarantee} onChange={e => this.setItemValue('guarantee', e.target.checked, item.id)} type="checkbox" />
						ضمانتی
					</div>
					<div className="col-sm-12">
						توضیحات:
						<input defaultValue={item.description} onChange={e => this.setItemValue('description', e.target.value, item.id)} autocomplete="off" type="text" className="description col-sm-11 form-control input-sm" />
					</div>
					<div className="col-lg-3">
						<div className="form-group">
							<label className="form-label">آپلود پیوست:</label>
							<div className="form-control-wrap">
								<input type="file" accept="image/*" onChange={(e) => this.handleAttachmentChange(e, item.id)} />
								{item.progress > 0 && (
									<div style={{ width: '100%', backgroundColor: '#eee', marginTop: '5px' }}>
										<div style={{ width: `${item.progress}%`, backgroundColor: 'green', color: 'white', padding: '0', textAlign: 'center', }} >
											{item.progress}%
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
					{!this.isBlank(item.attachmentUrl) && <div className="col-lg-3">
						<div className="form-group">
							<a href={item.attachmentUrl} target="_blank">مشاهده پیوست</a>
						</div>
					</div>}
				</div>
			</div>
			<a onClick={e => this.removeRow(item.id)} className="hand" style={{ "width": "10px", "height": "20px", "position": "absolute", "color": "#bd6432", "left": "0", "cursor": "pointer", "top": "0" }}>x</a>
		</div>
	}
	renderSafteBox(item) {
		return <div className="row mr-10 acc-pay-get-box " style={{ "background-color": "#bd6532", "border": "1px solid #bd6532", "position": "relative" }}>
			<div className="col-sm-1 text-center" style={{ "min-height": "85px", "display": "table" }}>
				<div style={{ "display": "table-cell", "vertical-align": "middle", "color": "white" }}>چـک</div>
			</div>
			<div className="col-sm-11 pd-10" style={{ "background-color": "white", "color": "rgb(34, 34, 34)" }}>
				<div className="row p-1" style={{ "margin-left": "5px" }}>
					<div className="col-sm-3" key={this.state.version + item.id + "_price"}>
						مبلغ ({this.state.data.global.company.currencyUnit})<span className="red">*</span>:
						<input defaultValue={item.price} onChange={e => this.setItemValue('price', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>
					{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-sm-3">ارز<span className="red">*</span>:
						<select defaultValue={item.currencyId} onChange={e => this.setItemValue('currencyId', e.target.value, item.id)} className='form-control text-center ltr'>
							<option value="">انتخاب</option>
							{this.state.data.global.currencies.map(cur => <option value={cur.value}>{cur.label}</option>)}
						</select>
					</div>}
					{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-sm-3">نرخ ارز<span className="red">*</span>:
						<input value={item.currencyRate} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>}
					{this.state.data.global.company.enableMultiCurrency === 2 && <div className="col-sm-3" key={this.state.version2 + item.id + "_price2"}>مبلغ ارزی<span className="red">*</span>:
						<input defaultValue={item.price2} onChange={e => this.setItemValue('price2', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>}
					<div className="col-sm-2">
							شماره سفته<span className="red">*</span>:
							<input defaultValue={item.chequeNumber} onChange={e => this.setItemValue('chequeNumber', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="cheque_number col-sm-2 form-control input-sm" />
						</div>
					<div className="col-sm-12">
						شرح:
						<input defaultValue={item.description} onChange={e => this.setItemValue('description', e.target.value, item.id)} autocomplete="off" type="text" className="description col-sm-11 form-control input-sm" />
					</div>
					<div className="col-lg-3">
						<div className="form-group">
							<label className="form-label">آپلود پیوست:</label>
							<div className="form-control-wrap">
								<input type="file" accept="image/*" onChange={(e) => this.handleAttachmentChange(e, item.id)} />
								{item.progress > 0 && (
									<div style={{ width: '100%', backgroundColor: '#eee', marginTop: '5px' }}>
										<div style={{ width: `${item.progress}%`, backgroundColor: 'green', color: 'white', padding: '0', textAlign: 'center', }} >
											{item.progress}%
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
					{!this.isBlank(item.attachmentUrl) && <div className="col-lg-3">
						<div className="form-group">
							<a href={item.attachmentUrl} target="_blank">مشاهده پیوست</a>
						</div>
					</div>}
				</div>
			</div>
			<a onClick={e => this.removeRow(item.id)} className="hand" style={{ "width": "10px", "height": "20px", "position": "absolute", "color": "#bd6432", "left": "0", "cursor": "pointer", "top": "0" }}>x</a>
		</div>
	}
	changeObjectType(e) {
		this.state.data.record.objectType = e;
		this.setState({ data: this.state.data });
	}
	setPerson(e) {
		if (e.value == -1) {
			this.state.data.record.personId = this.defaultGuid();
			this.state.data.record.personName = '';
			this.showComponents({ component: <Person Caller={this} FromAutoComplete={true} /> });
			return;
		}
		this.state.data.record.personId = e.value;
		this.state.data.record.personName = e.label;
		this.setState({ data: this.state.data });
	}
	setBankAccount(e, itemId) {
		if (e.value == -1) {
			this.setItemValue('bankAccountId', this.defaultGuid(), itemId);
			this.setItemValue('bankAccountName', '', itemId);
			this.showComponents({ component: <BankAccount CallbackData={{ itemId: itemId }} OnSetBank={(e, c, p) => { c.setBankAccount(e, p.itemId) }} Caller={this} FromAutoComplete={true} /> });
			return;
		}
		this.setItemValue('bankAccountId', e.value, itemId);
		this.setItemValue('bankAccountName', e.label, itemId);
		this.setState({ data: this.state.data });
	}
	setCashdesk(e, itemId) {
		if (e.value == -1) {
			this.setItemValue('cashDeskId', this.defaultGuid(), itemId);
			this.setItemValue('cashDeskName', '', itemId);
			this.showComponents({ component: <CashDesk CallbackData={{ itemId: itemId }} OnSetCashDesk={(e, c, p) => { c.setCashdesk(e, p.itemId) }} Caller={this} FromAutoComplete={true} /> });
			return;
		}
		this.setItemValue('cashDeskId', e.value, itemId);
		this.setItemValue('cashDeskName', e.label, itemId);
		this.setState({ data: this.state.data });
	}
	setMoein(e) {
		this.state.data.record.moeinAccountId = e.value;
		this.state.data.record.moeinName = e.label;
	}
	setTafsil(e) {
		this.state.data.record.tafsilAccountId = e.value;
		this.state.data.record.tafsilName = e.label;
	}
	setUnit(e) {
		this.state.data.record.billExpenseUnitId = null
		this.state.data.record.description = '';
		this.setState({ unitId: e.value });
	}
	setBillExponse(e) {
		this.state.data.record.billExpenseUnitId = e.value;
		if (e.billExpenseType === 1) this.state.data.record.type = 1;
		if (e.billExpenseType === 2) this.state.data.record.type = 2;
		if (e.billExpenseType === 3) this.state.data.record.type = 2;
		this.state.data.record.description = e.label;
		this.setState({ data: this.state.data });
	}
	handleAttachmentUpload = (file, id) => {
		const formData = new FormData();
		formData.append('file', file);

		const endpoint = '/api/v1/media/upload';
		const xhr = new XMLHttpRequest();

		xhr.open('POST', endpoint, true);

		xhr.upload.onprogress = (event) => {
			if (event.lengthComputable) {
				const percent = Math.round((event.loaded * 100) / event.total);
				this.setItemValue('progress', percent, id);
			}
		};

		xhr.onload = () => {
			if (xhr.status === 200) {
				const response = JSON.parse(xhr.responseText);
				this.setItemValue('progress', 100, id);
				this.setItemValue('attachment', response.url, id);
				this.setItemValue('attachmentUrl', response.url, id);
			} else {
				console.error('آپلود با خطا مواجه شد:', xhr.statusText);
			}
		};

		xhr.onerror = () => {
			console.error('خطا در ارسال فایل');
			this.setItemValue('progress', 0, id);
		};

		xhr.send(formData);
	}
	handleAttachmentChange = (e, id = null) => {
		const file = e.target.files[0];
		if (file) {
			this.handleAttachmentUpload(file, id);
		}
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
			<div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
				<div className="modal-content">
					<div className="modal-body">
						<div className="modal-header modal-header-info" style={{ "padding": "0" }}>
							<button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
							<h4 className="modal-title">
								{this.state.data.record.type === 1 && <span>دریافت</span>}
								{this.state.data.record.type === 2 && <span>پرداخت</span>}
								{this.state.data.record.type === 3 && <span>دریافت</span>}
								{this.state.data.record.type === 4 && <span>انتقال وجه</span>}
							</h4>
						</div>
						<div className="modal-body">
							<div className="row">

								{(this.state.data.record.type !== 3 && this.state.data.record.type !== 4) && this.state.data.global.company.mainBussinessType === 4 && [
									<div className="col-sm-4 mb-2">
										<div className="form-group">
											<label>انتخاب واحد ساختمان<span className="red">*</span></label>
											<SelectAsync
												//defaultValue={this.state.data.record.billExpenseId != this.getDefaultGuid() ? [{ value: this.state.data.record.billExpenseId, label: this.state.data.record.billEexpenseAutoDescription }] : null}
												isMulti={false}
												placeholder="انتخاب واحد"
												defaultOptions
												loadOptions={(inputValue, callback) => this.loadBuildingUnitsOptions(inputValue, callback, this.state.buildingId, 0)}
												onChange={e => this.setUnit(e)}
											/>
										</div>
									</div>,
									this.state.unitId !== null && <div className="col-sm-8 mb-2" key={this.state.unitId}>
										<div className="form-group">
											<label>موضوع صورتحساب<span className="red">*</span></label>
											<SelectAsync
												//defaultValue={this.state.data.record.billExpenseId != this.getDefaultGuid() ? [{ value: this.state.data.record.billExpenseId, label: this.state.data.record.billEexpenseAutoDescription }] : null}
												isMulti={false}
												placeholder="موضوع صورتحساب"
												defaultOptions
												loadOptions={(inputValue, callback) => this.loadBillExpenseUnitsOptions(inputValue, callback, this.state.buildingId, 0, this.state.unitId)}
												onChange={e => this.setBillExponse(e)}
											/>
										</div>
									</div>
								]}

								{this.state.data.record.source === 1 && <div className="col-sm-2">
									{this.state.data.record.factorId != this.defaultGuid() && !this.isNull(this.state.data.record.factorId) && <div className="form-group">
										{this.state.data.record.type === 1 ?
											<label>دریافت بابت فاکتور شماره: {this.state.data.factor.number}</label>
											:
											<label>پرداخت بابت فاکتور شماره: {this.state.data.factor.number}</label>
										}
									</div>}
									{this.state.data.record.installmentScheduleId != this.defaultGuid() && !this.isNull(this.state.data.record.installmentScheduleId) && <div className="form-group">
										{this.state.data.record.type === 1 ?
											<label>دریافت بابت قسط شماره: {this.state.data.installmentSchedule.contractNumber}</label>
											:
											<label> پرداخت بابت قسط شماره: {this.state.data.installmentSchedule.contractNumber}</label>
										}
									</div>}
									{(this.state.data.record.type !== 3 && this.state.data.record.type !== 4) && 
										((this.state.data.record.installmentScheduleId == this.defaultGuid() || this.isNull(this.state.data.record.installmentScheduleId))) &&
										((this.state.data.record.factorId == this.defaultGuid() || this.isNull(this.state.data.record.factorId))) &&
										<div className="form-group">
											{this.state.data.record.type === 1 ?
												<label>دریافت از</label>
												:
												<label>پرداخت به</label>
											}
											<div>
												<select defaultValue={this.state.data.record.objectType} onChange={e => this.changeObjectType(parseInt(e.target.value))} className="form-control">
													<option value="1">شخص</option>
													<option value="2">سایر</option>
												</select>
											</div>
										</div>}
								</div>}

								{(this.state.data.record.type !== 3 && this.state.data.record.type !== 4) && ((this.state.data.record.installmentScheduleId == this.defaultGuid() || this.isNull(this.state.data.record.installmentScheduleId))) &&
									this.state.data.record.objectType === 1 && <div className="col-sm-4">
									<div className="form-group">
										<label>شخص {this.state.data.record.type === 1 ? "پرداخت کننده" : ""}{this.state.data.record.type === 2 ? "دریافت کننده" : ""}<span className="red">*</span></label>
										<SelectAsync
											value={this.state.data.record.personId != this.defaultGuid() ? [{ value: this.state.data.record.personId, label: this.state.data.record.personName }] : null}
											isMulti={false}
											placeholder="انتخاب شخص"
											defaultOptions
											loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 1,0)}
											onChange={e => this.setPerson(e)}
										/>
									</div>
								</div>}

								{(this.state.data.record.type !== 3 && this.state.data.record.type !== 4) && this.state.data.record.objectType === 2 && <div className="col-sm-4">
									<div className="form-group">
										<label>معین<span className="red">*</span></label>
										<SelectAsync
											style={{ "width": "100%" }}
											defaultValue={this.state.data.record.moeinAccountId !== this.getDefaultGuid() ? [{ value: this.state.data.record.moeinAccountId, label: this.state.data.record.moeinName }] : null}
											isMulti={false}
											placeholder="انتخاب حساب معین"
											defaultOptions
											loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3)}
											onChange={e => this.setMoein(e)}
										/>
									</div>
								</div>}
								{(this.state.data.record.type !== 3 && this.state.data.record.type !== 4) && this.state.data.record.objectType === 2 && <div className="col-sm-4">
									<div className="form-group">
										<label>تفصیلی<span className="red">*</span></label>
										<SelectAsync
											style={{ "width": "100%" }}
											defaultValue={this.state.data.record.tafsilAccountId !== this.getDefaultGuid() ? [{ value: this.state.data.record.tafsilAccountId, label: this.state.data.record.tafsilName }] : null}
											isMulti={false}
											placeholder="انتخاب حساب تفصیل"
											defaultOptions
											loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4)}
											onChange={e => this.setTafsil(e)}
										/>
									</div>
								</div>}
							</div>
							<div className="row mt-2">
								<div className="col-sm-1">
									<div className="form-group">
										{this.state.data.record.type === 3 ? <label>از تاریخ</label> : <label>تاریخ</label>}
										{this.state.enableDatePicker === true ? <DatePicker
											inputReadOnly={false}
											className="form-control input-sm persian-date"
											placeholder={"تاریخ"}
											isGregorian={false}
											showTodayButton={true}
											timePicker={false}
											onChange={(e) => { this.state.data.record.date = e }}
											value={this.getFormatedDateForDatePicker(this.state.data.record.date)}
										/> :
											<input
												onChange={(e) => this.state.data.record.dateString = e.target.value}
												defaultValue={this.state.data.record.dateString}
												autoComplete="off"
												placeholder={'تاریخ'}
												type="text"
												className="form-control ltr"
												maxLength="10"
											/>}
									</div>
								</div>
								{this.state.data.record.type === 3 && <div className="col-sm-1">
									<div className="form-group">
										<label>تا تاریخ</label>
										{this.state.data.record.type === 3 ? <DatePicker
											inputReadOnly={false}
											className="form-control input-sm persian-date"
											placeholder={"تا تاریخ"}
											isGregorian={false}
											showTodayButton={true}
											timePicker={false}
											onChange={(e) => { this.state.data.record.toDate = e }}
											value={this.getFormatedDateForDatePicker(this.state.data.record.toDate)}
										/> :
										<input
											onChange={(e) => this.state.data.record.toDateString = e.target.value}
											defaultValue={this.state.data.record.toDateString}
											autoComplete="off"
											placeholder={'تا تاریخ'}
											type="text"
											className="form-control ltr"
											maxLength="10"
										/>}
									</div>
								</div>}
								<div className="col-sm-11">
									<div className="form-group">
										<label>شرح<span className="red">*</span></label>
										<input type="text" disabled={this.state.data.record.source === 2} defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} rows="2" className="form-control input-smng-touched" maxlength="200" placeholder="شرح ..." />
									</div>
								</div>
							</div>
							
							{this.state.data.record.type !== 3 && this.state.data.record.type !== 4 && <div className="row mt-4">
								<div className="col-sm-12">
									<div className="btn-group" role="group">
										<button type="button" className="btn btn-primary btn-sm hand" onClick={e => this.addNewNagdRow()}>
											افزودن {this.state.data.record.type === 1 ? "دریافت" : ""}{this.state.data.record.type === 2 ? "پرداخت" : ""} نقدی
										</button>
										<button type="button" className="btn btn-primary btn-sm hand" onClick={e => this.addNewFishRow()}>
											افزودن {this.state.data.record.type === 1 ? "دریافت" : ""}{this.state.data.record.type === 2 ? "پرداخت" : ""} فیش بانکی
										</button>
										<button type="button" className="btn btn-primary btn-sm hand" onClick={e => this.addNewChequeRow()}>
											افزودن {this.state.data.record.type === 1 ? "دریافت" : ""}{this.state.data.record.type === 2 ? "پرداخت" : ""} چک
										</button>
										<button type="button" className="btn btn-primary btn-sm hand" onClick={e => this.addNewSafteRow()}>
											افزودن {this.state.data.record.type === 1 ? "دریافت" : ""}{this.state.data.record.type === 2 ? "پرداخت" : ""} سفته
										</button>
									</div>
								</div>
							</div>}

							{this.state.data.record.type === 3 && <div className="row mt-4">
								<div className="col-sm-12">
									<div className="btn-group" role="group">
										<button type="button" className="btn btn-primary btn-sm hand" onClick={e => this.addNewRow()}>
											افزودن دریافتی
										</button>
									</div>
								</div>
							</div>}

							{this.state.data.record.type === 4 && <div className="row mt-4">
								<div className="col-sm-12">
									<div className="btn-group" role="group">
										<button type="button" className="btn btn-primary btn-sm hand" onClick={e => this.addNewRow()}>
											افزودن انتقال
										</button>
									</div>
								</div>
							</div>}

							{this.state.data.record.type !== 3 && <div className="separator1 mr-t-10">
								{this.state.data.receiptItems.map(m => [
									m.objectType === 1 && this.renderNagdBox(m),
									m.objectType === 2 && this.renderFishBox(m),
									m.objectType === 3 && this.renderChequeBox(m),
									m.objectType === 4 && this.renderOnlinePay(m),
									m.objectType === 6 && this.renderSafteBox(m),
								])}
							</div>}

							{this.state.data.record.type === 3 && !this.isEmpty(this.state.data.receiptItems) && <table className="table table-bordered acc_grid_row">
								<thead>
									<tr className="active">
										<td>از حساب</td>
										<td>به حساب</td>
										<td>شرح</td>
										<td style={{ "width": "100px" }}>مبلغ <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></td>
										{this.state.data.global.company.enableMultiCurrency === 2 && <td>ارز</td>}
										{this.state.data.global.company.enableMultiCurrency === 2 && <td>نرخ</td>}
										{this.state.data.global.company.enableMultiCurrency === 2 && <td>مبلغ ارزی</td>}
										<td style={{ "width": "75px" }}>پیوست</td>
										{this.state.data.record.status === 0 && <td style={{ "width": "35px" }}></td>}
									</tr>
								</thead>
								<tbody>
									{this.state.data.receiptItems.map((item, index) =>
										<tr key={item.id}>
											<td>
												<SelectAsync
													defaultValue={
														item.fromAccountId !== null
															? [
																{
																	value: item.fromAccountId,
																	label: item.fromAccountName,
																},
															]
															: null
													}
													isMulti={false}
													placeholder="انتخاب"
													components={{
														//DropdownIndicator: () => null,
														IndicatorSeparator: () => null,
													}}
													noOptionsMessage={({ inputValue }) =>
														inputValue ? "نتیجه‌ای یافت نشد" : null
													}
													defaultOptions={[]}
													loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4, null, [1])}
													onChange={(e) =>
														this.setItemValue('fromAccountId', e, item.id)
													}
												/>
											</td>
											<td>
												<SelectAsync
													defaultValue={
														item.toAccountId !== null
															? [
																{
																	value: item.toAccountId,
																	label: item.toAccountName,
																},
															]
															: null
													}
													isMulti={false}
													placeholder="انتخاب"
													components={{
														//DropdownIndicator: () => null,
														IndicatorSeparator: () => null,
													}}
													noOptionsMessage={({ inputValue }) =>
														inputValue ? "نتیجه‌ای یافت نشد" : null
													}
													defaultOptions={[]}
													loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4, null, [4,1])}
													onChange={(e) =>
														this.setItemValue('toAccountId', e, item.id)
													}
												/>
											</td>
											<td>
												<input type="text" className="form-control text-center" defaultValue={item.description} onChange={e => this.setItemValue('description', e.target.value, item.id)} />
											</td>
											<td><NumberFormat value={item.price} onChange={e => this.setItemValue('price', parseInt(e.target.value.replace(/,/g, '')), item.id)} key={this.state.version + item.id + "_price"} thousandSeparator={true} prefix={''} className='form-control text-center ltr' /></td>

											{this.state.data.global.company.enableMultiCurrency === 2 && <td>
												<select defaultValue={item.currencyId} onChange={e => this.setItemValue('currencyId', e.target.value, item.id)} className='form-control text-center ltr'>
													<option value="">انتخاب</option>
													{this.state.data.global.currencies.map(cur => <option value={cur.value}>{cur.label}</option>)}
												</select>
											</td>}
											{this.state.data.global.company.enableMultiCurrency === 2 && <td>
												<input value={item.currencyRate} onChange={e => this.setItemValue('currencyRate', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="form-control text-center ltr" />
											</td>}
											{this.state.data.global.company.enableMultiCurrency === 2 && <td>
												<input readOnly={true} defaultValue={item.price2} onChange={e => this.setItemValue('price2', parseInt(e.target.value), item.id)} key={this.state.version2 + item.id + "_price2"} autocomplete="off" type="text" className="form-control text-center ltr" />
											</td>}

											<td>
												<div className="form-control-wrap">
													<input type="file" accept="image/*" onChange={(e) => this.handleAttachmentChange(e, item.id)} />
													{item.progress > 0 && (
														<div style={{ width: '100%', backgroundColor: '#eee', marginTop: '5px' }}>
															<div style={{ width: `${item.progress}%`, backgroundColor: 'green', color: 'white', padding: '0', textAlign: 'center', }} >
																{item.progress}%
															</div>
														</div>
													)}
												</div>
												{!this.isBlank(item.attachmentUrl) && <div className="col-lg-3">
													<div className="form-group">
														<a href={item.attachmentUrl} target="_blank">مشاهده پیوست</a>
													</div>
												</div>}
											</td>
											<td>
												<span title="حذف سطر" onClick={e => this.removeRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>
											</td>
										</tr>
									)}
								</tbody>
							</table>}

							{this.state.data.record.type === 4 && !this.isEmpty(this.state.data.receiptItems) && <table className="invoices-table persons-table">
								<thead>
									<tr>
										<td style={{ width: '150px', backgroundColor: "#ffe6e6" }} >مبدا</td>
										<td style={{ width: '100px', backgroundColor: "#ffe6e6" }}>مبلغ({this.state.data.global.company.currencyUnit})</td>
										{this.state.data.global.company.enableMultiCurrency === 2 && <td style={{ width: '50px', backgroundColor: "#ffe6e6" }}>ارز</td>}
										{this.state.data.global.company.enableMultiCurrency === 2 && <td style={{ width: '80px', backgroundColor: "#ffe6e6" }}>نرخ</td>}
										{this.state.data.global.company.enableMultiCurrency === 2 && <td style={{ width: '80px', backgroundColor: "#ffe6e6" }}>مبلغ ارزی</td>}

										<td style={{ width: '150px', backgroundColor: "#e6ffe9" }}>مقصد</td>
										<td style={{ width: '100px', backgroundColor: "#e6ffe9" }}>مبلغ({this.state.data.global.company.currencyUnit})</td>
										{this.state.data.global.company.enableMultiCurrency === 2 && <td style={{ width: '50px', backgroundColor: "#e6ffe9" }}>ارز</td>}
										{this.state.data.global.company.enableMultiCurrency === 2 && <td style={{ width: '80px', backgroundColor: "#e6ffe9" }}>نرخ</td>}
										{this.state.data.global.company.enableMultiCurrency === 2 && <td style={{ width: '80px', backgroundColor: "#e6ffe9" }}> مبلغ ارزی</td>}

										<td style={{ width: '90px' }}>کارمزد({this.state.data.global.company.currencyUnit})</td>
										<td>شرح</td>
										<td style={{ width: '75px' }}>پیوست</td>
										{this.state.data.record.status === 0 && (
											<td style={{ width: '35px' }}></td>
										)}
									</tr>
								</thead>
								<tbody>
									{this.state.data.receiptItems.map((item, index) => (
										<tr key={item.id}>
											<td>
												<SelectAsync
													defaultValue={
														item.fromAccountId !== null
															? [
																{
																	value: item.fromAccountId,
																	label: item.fromAccountName,
																},
															]
															: null
													}
													isMulti={false}
													placeholder="انتخاب"
													components={{
														//DropdownIndicator: () => null,
														IndicatorSeparator: () => null,
													}}
													noOptionsMessage={({ inputValue }) =>
														inputValue ? "نتیجه‌ای یافت نشد" : null
													}
													defaultOptions={[]}
													loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4, null, [3, 4])}
													onChange={(e) =>
														this.setItemValue('fromAccountId', e, item.id)
													}
												/>
											</td>

											<td>
												<NumberFormat
													value={item.price}
													onChange={(e) => this.setItemValue('price', parseInt(e.target.value.replace(/,/g, '')), item.id)}
													thousandSeparator={true}
													prefix={''}
													className="form-input text-center ltr" key={this.state.version + item.id + "_price"}
												/>
											</td>

											{this.state.data.global.company.enableMultiCurrency === 2 && <td>
												<select defaultValue={item.currencyId} onChange={e => this.setItemValue('currencyId', e.target.value, item.id)} className='form-select text-center ltr'>
													<option value="">انتخاب</option>
													{this.state.data.global.currencies.map(cur => <option value={cur.value}>{cur.label}</option>)}
												</select>
											</td>}
											{this.state.data.global.company.enableMultiCurrency === 2 && <td>
												<input value={item.currencyRate} onChange={e => this.setItemValue('currencyRate', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="form-input text-center ltr" />
											</td>}
											{this.state.data.global.company.enableMultiCurrency === 2 && <td>
												<input readOnly={true} defaultValue={item.price2} onChange={e => this.setItemValue('price2', parseInt(e.target.value), item.id)} key={this.state.version2 + item.id + "_price2"} autocomplete="off" type="text" className="form-input text-center ltr" />
											</td>}


											<td>
												<SelectAsync
													defaultValue={
														item.toAccountId !== null
															? [
																{
																	value: item.toAccountId,
																	label: item.toAccountName,
																},
															]
															: null
													}
													isMulti={false}
													placeholder="انتخاب"
													components={{
														//DropdownIndicator: () => null,
														IndicatorSeparator: () => null,
													}}
													noOptionsMessage={({ inputValue }) =>
														inputValue ? "نتیجه‌ای یافت نشد" : null
													}
													defaultOptions={[]}
													loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4, null, [3, 4])}
													onChange={(e) =>
														this.setItemValue('toAccountId', e, item.id)
													}
												/>
											</td>
											<td>
												<NumberFormat
													value={item.priceTo}
													onChange={(e) => this.setItemValue('priceTo', parseInt(e.target.value.replace(/,/g, '')), item.id)}
													thousandSeparator={true}
													prefix={''}
													className="form-input text-center ltr" key={this.state.version + item.id + "_priceTo"}
												/>
											</td>
											{this.state.data.global.company.enableMultiCurrency === 2 && <td>
												<select defaultValue={item.currencyToId} onChange={e => this.setItemValue('currencyToId', e.target.value, item.id)} className='form-select text-center ltr'>
													<option value="">انتخاب</option>
													{this.state.data.global.currencies.map(cur => <option value={cur.value}>{cur.label}</option>)}
												</select>
											</td>}
											{this.state.data.global.company.enableMultiCurrency === 2 && <td>
												<input value={item.currencyRateTo} onChange={e => this.setItemValue('currencyRateTo', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="form-input text-center ltr" />
											</td>}
											{this.state.data.global.company.enableMultiCurrency === 2 && <td>
												<input readOnly={true} defaultValue={item.priceTo2} onChange={e => this.setItemValue('priceTo2', parseInt(e.target.value), item.id)} key={this.state.version2 + item.id + "_priceTo2"} autocomplete="off" type="text" className="form-input text-center ltr" />
											</td>}

											<td>
												<NumberFormat
													value={item.wage}
													onChange={(e) => this.setItemValue('wage', parseInt(e.target.value.replace(/,/g, '')), item.id)}
													thousandSeparator={true}
													prefix={''}
													className="form-input text-center ltr" key={this.state.version + item.id + "_wage"}
												/>
											</td>
											<td>
												<input type="text" className="form-input text-center" defaultValue={item.description} onChange={(e) => this.setItemValue('description', e.target.value, item.id)} />
											</td>
											<td>
												<div className="form-control-wrap">
													<input type="file" accept="image/*" onChange={(e) => this.handleAttachmentChange(e, item.id)} />
													{item.progress > 0 && (
														<div style={{ width: '100%', backgroundColor: '#eee', marginTop: '5px' }}>
															<div style={{ width: `${item.progress}%`, backgroundColor: 'green', color: 'white', padding: '0', textAlign: 'center', }} >
																{item.progress}%
															</div>
														</div>
													)}
												</div>
												{!this.isBlank(item.attachmentUrl) && <div className="col-lg-3">
													<div className="form-group">
														<a href={item.attachmentUrl} target="_blank">مشاهده پیوست</a>
													</div>
												</div>}
											</td>
											<td>
												<div className="item-actions">
													<button title="حذف سطر" onClick={(e) => this.removeRow(item.id)} className="item-delete-btn">
														<i className="mir-trash text-danger"></i>
													</button>
												</div>
											</td>
										</tr>
									))}
								</tbody>
							</table>}

							<div className="row mr-t-10">
								<div className="col-sm-12">
									<div className="form-group">
										<label>یادداشت</label>
										<textarea defaultValue={this.state.data.record.note} onChange={e => this.state.data.record.note = e.target.value} rows="2" style={{ "height": "52px" }} className="form-control input-smng-touched" maxlength="200" placeholder="یادداشت ..."></textarea>
									</div>
								</div>
							</div>
							<div className="row mt-4">
								<div className="col-md-8">
								</div>
								<div className="col-md-4">
									<div className="row text-left pb-2" style={{ "border-bottom": "1px solid rgb(69, 69, 69)" }} >
										<div className="col-md-4 h5 txt-bold">جمع <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></div>
										<div className="col-md-7 h5 txt-bold">{this.money(this.state.data.record.total)} {this.state.data.global.company.currencyUnit}</div>
									</div>
								</div>
							</div>

							{this.state.data.record.id !== this.getDefaultGuid() && <div>
								<WorkFlowStepLogging Caller={this} EntityId={this.state.data.record.id} WorkFlowStepId={this.state.data.record.workFlowStepId} Type={4} />
							</div>}

						</div>
						<div className="modal-footer">
							<button onClick={e => this.save(e)} className="hand btn btn-primary">ذخیره</button>
							{this.state.data.record.id != this.defaultGuid() && <button type="button" className="me-2 btn btn-danger">حذف </button>}
							<button type="button" className="btn btn-warning" onClick={e => this.closeMe()}>انصراف </button>

						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.renderForm(),
				this.renderPopupComponent()
			];

		return contents;
	}
}